export type OrgSecondaryReportsVisibilityMode = 'hidden' | 'selection' | 'always';

/**
 * Dotted lines (matrix reports and secondary seats) show only around the
 * selected person by default. A source-backed chart where many people hold
 * several seats draws one dotted line per extra seat, and with every line
 * always on the tree reads as a tangle. The Display panel can still set
 * "always" or "hidden" per diagram.
 */
export const DEFAULT_ORG_SECONDARY_REPORTS_VISIBILITY_MODE: OrgSecondaryReportsVisibilityMode =
  'selection';
